const styles = {
  fieldTitleProps: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '250px',
    whiteSpace: 'nowrap'
  },
  fieldRowProps: {
    justifyContent: 'center',
    alignItems: 'center',
    py: '4px',
    mb: 2
  },

  imageStyles: {
    maxHeight: '250px',
    maxWidth: '250px',
    objectFit: 'contain',
    width: '100%',
    borderRadius: 'var(--card-radius)'
  }
}

export default styles
